// extracted by mini-css-extract-plugin
export default {"step_text":"StepHeader_step_text__rwiNo","container":"StepHeader_container__bR9MY","back_button":"StepHeader_back_button__ahomB"};